// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review_4U75J{display:grid;grid-gap:8px;align-items:flex-start;border-bottom:1px solid var(--cp-gray-5);gap:8px;padding:24px 0}@media only screen and (min-width:1264px){.review_4U75J.isProductPage_0DjzX{gap:25px;grid-template-columns:192px 1fr 240px;padding:32px 0}}.review_4U75J:last-child:not(.isProductPage_0DjzX){border-bottom:none}@media only screen and (min-width:1264px){.review_4U75J:last-child{border-bottom:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"review": "review_4U75J",
	"isProductPage": "isProductPage_0DjzX"
};
module.exports = ___CSS_LOADER_EXPORT___;
